// extracted by mini-css-extract-plugin
export var internalNoteEditor = "_i5-1";
export var quotedThread = "_i5-0";